import logoIMGW from "../assets/imgw.png"
import logoWindy from "../assets/windy.png"
import logoICM from "../assets/icm.png"
import logoSSH from "../assets/ssh.png"

export default function Footer(){
    return(
        <footer>
            <a
                href="https://www.windy.com"
                target="_blank"
                title="windy"
                rel="noreferrer"
            >
            <img
                src={logoWindy}
                alt="Windy"
                className="footer--icon"
            /></a>
            <a
                href="http://www.meteo.mil.pl/"
                target="_blank"
                title="SSH SZRP"
                rel="noreferrer"
            >
            <img
                src={logoSSH}
                alt="SSH SZRP"
                className="footer--icon"
            /></a>
            <a
                href="https://m.meteo.pl"
                target="_blank"
                title="ICM"
                rel="noreferrer"
            >
            <img
                src={logoICM}
                alt="ICM"
                className="footer--icon"
            /></a>
            <a
                href="https://awiacja.imgw.pl"
                target="_blank"
                title="Awiacja IMGW"
                rel="noreferrer"
            >
            <img
                src={logoIMGW}
                alt="Awiacja IMGW"
                className="footer--icon"
            /></a>
        </footer>
    )
}